export const companySalesTeamTranslation = {
  title: 'company_sales_team-title',
  emptySalesTeamContent: 'company_sales_team-empty_sales_team_content',
  leadPBM: 'company_sales_team-lead_pbm',
  email: 'company_sales_team-email',
  msTeamChat: 'company_sales_team-ms_team_chat',
  msTeamCall: 'company_sales_team-ms_team_call',
  name: 'company_sales_team-name',
  role: 'company_sales_team-role',
  bUnit: 'company_sales_team-bUnit',
  assignmentPeriod: 'company_sales_team-assignmentPeriod',
}
